<template>
  <div class="g-order-list">
    <div class="order-list-top">
      <div class="top-l">
        <el-input v-model="VIN" clearable placeholder="请输入VIN"></el-input>
        <el-date-picker
        v-model="start_time"
        type="date"
        placeholder="选择开始日期">
        </el-date-picker>
        <el-date-picker
        v-model="end_time"
        :picker-options="pickerOptions1"
        type="date"
        placeholder="选择结束日期">
        </el-date-picker>
        <el-button class="top-l-search" @click="searchClick()">查询</el-button>
        <el-button class="top-l-search top-l-export" @click="exportbtnClick()">导出</el-button>
        <div style="clear:both;"></div>
      </div>
      <div style="clear:both;"></div>
    </div>
    <div class="order-list-bottom">
      <div class="order-list-table">
        <el-table
        :data="yemiandata"
        :header-cell-style="{background:'#f3f3f3',color:'#323232',height:'50px'}"
        border
        style="width: 100%">
            <el-table-column
            prop="name"
            label="客户"
            width="130">
              <template slot-scope="scope">{{ scope.row.name | defaultValFilter }}</template>
            </el-table-column>
            <el-table-column
            prop="vin"
            label="VIN"
            width="">
            </el-table-column>
            <el-table-column
            prop="batch"
            label="订单号">
            </el-table-column>
            <el-table-column
            prop="customer_status"
            label="付款方式"
            width="80">
                <template slot-scope="scope">
                  <span v-if="scope.row.customer_status==1" style="color:#0071bd;">月结</span>
                  <span v-else-if="scope.row.customer_status==2" style="color:#ee0000;">即时结算</span>
                </template>
            </el-table-column>
            <el-table-column
            prop="start_time"
            label="开始时间"
            width="160">
            </el-table-column>
            <el-table-column
            prop="end_time"
            label="结束时间"
            width="160">
            </el-table-column>
            <el-table-column
            prop="openid"
            label="openId">
              <template slot-scope="scope">{{ scope.row.openid | defaultValFilter }}</template>
            </el-table-column>
            <el-table-column
            prop="nickname"
            label="微信用户名">
              <template slot-scope="scope">{{ scope.row.nickname | defaultValFilter }}</template>
            </el-table-column>
            <el-table-column
            prop="total_power"
            label="电量"
            width="120">
            </el-table-column>
            <el-table-column
            prop="total_power_fee"
            label="电费"
            width="120">
            </el-table-column>
            <el-table-column
            prop="serv_fee"
            label="服务费"
            width="120">
            </el-table-column>
            <el-table-column
            prop="elce_fee"
            label="总费用"
            width="120">
            </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          @size-change="handleSizeChange"
          @current-change="currentChange"
          :total="totalNum"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { parseDateFilter } from "@/filters";
import API_ROOT from "../../../config/dev.env"
export default {
  data() {
    return {
      tableData: [],
      // 页面需要展现的数据
      yemiandata: [],
      // 页面展现条数
      datanum: 10,
      // 开始页数
      startnum: 0,
      // 结束页数
      endnum: 1,
      // 一共多少页
      totalNum: 0,
      value: "",
      options:[],
      pickerOptions1: {
        disabledDate: (time) => {
          return time.getTime() < this.start_time || time.getTime() > Date.now();
        }
      },
      VIN:"",
      start_time:"",
      end_time:"",
      linkurl:"",
    };
  },
  mounted() {
    this.$nextTick(function() {
      this.getDataList();
    });
  },
  methods: {
    handleSizeChange(data){
      // debugger
    },
    currentChange(data){
      this.endnum = data;
      this.startnum = data-1;
      // this.yemiandata=this.tableData.slice(this.startnum*this.datanum,this.endnum*this.datanum);
      if(this.totalNum > 10){
        this.yemiandata=this.tableData.slice(this.startnum*this.datanum,this.endnum*this.datanum);
      } else {
        this.yemiandata=this.tableData;
      }
    },
    getDataList(vin,startTime,endTime){
      if(vin == undefined){
        vin = "";
      }
      if(startTime == undefined){
        startTime = "";
      }
      if(endTime == undefined){
        endTime = "";
      }
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action:"getCustomerOrders",
        vin:vin,
        start_date:startTime ? parseDateFilter(startTime, 'yyyy-MM-dd') : '',
        end_date:endTime ? parseDateFilter(endTime, 'yyyy-MM-dd') : '',
      };
      this.$api({
        method: "post",
        url: "/api.php/Customer2/index",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if (su.data.code == 1) {
            this.tableData = su.data.list;
            this.totalNum = this.tableData.length;
            if(this.totalNum > 10){
              // debugger
              this.yemiandata=this.tableData.slice(this.startnum*this.datanum,this.endnum*this.datanum);
            } else {
              this.yemiandata=this.tableData;
            }
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900)  {
          } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch(err => {});
    },
    searchClick(){
      this.startnum = 0;
      this.endnum = 1;
      this.totalNum = 0;
      this.getDataList(this.VIN,this.start_time,this.end_time);
    },
    // 导出
    exportbtnClick() {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action:"exportCustomerOrders",
        vin:this.VIN,
        start_date:this.start_time ? parseDateFilter(this.start_time, 'yyyy-MM-dd') : '',
        end_date:this.end_time ? parseDateFilter(this.end_time, 'yyyy-MM-dd') : '',
      };

      this.$api({
        method: "post",
        url: "/api.php/Customer2/index",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if (su.data.code == 1) {
            this.linkurl = su.data.url;
            this.createAndDownloadFile(su.data.url);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 302) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == 303) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == 304) {
            this.$message.warning(su.data.message);
          }
        })
        .catch(err => {});
    },
    /**
     * 导出调用方法
     */
    createAndDownloadFile(content) {
       let link = document.createElement("a");
      let contentArr = content.split("/");
      contentArr[0] = JSON.parse(API_ROOT.API_ROOT);
      content =
        contentArr[0] +
        "/" +
        contentArr[1] +
        "/" +
        contentArr[2] +
        "/" +
        contentArr[3];

      link.href = content;
      link.click();
    },
  }
};
</script>

<style scoped lang="scss">
.g-order-list {
  padding:20px 0;
  .order-list-top {
    .top-l {
      float: left;
      margin-left: 1%;
      .el-select {
        float: left;
        margin-right: 10px;
      }
      .el-input {
        width: 20%;
        float: left;
        margin-right: 10px;
      }
      .top-l-search {
        background-color: #0071bd;
        border: none;
        color: #fefffd;
        margin-left: 16px;
        float: left;
      }
      .top-l-export {
        background-color: #00b270;
      }
    }
  }
  .order-list-bottom {
    .order-list-table {
        width: 98%;
        margin-left: 1%;
        margin-top: 26px;
        margin-bottom: 10px;
        .table-btn {
            width: 54px;
            height: 30px;
            padding: 0;
            background-color: #006fbe;
            border:none;
            color: #fefffd;
            margin-left: 5px;
        }
        .table-vehicle {
            background-color: #00b270;
        }
        .table-dis {
            background-color: #eb0000;
        }
        .table-recharge {
            background-color: #ec6900;
        }
    }
    .pagination {
      display: flex;
      justify-content: flex-end;
      padding-bottom: 24px;
      margin-top: 20px;
      margin-right: 18px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/membershipManagement/gOrderList.vue